import { LOGIN } from "../types";
import { call, takeLatest, put } from "redux-saga/effects";
import { handleLoginApi } from "../api/auth-api";
import { loginSuccess, loginFailure, LoginCredentials } from "../actions/authActions";
import { AxiosResponse } from "axios";
import { fetchModuleGrants } from "../../utils/moduleGrants";

interface LoginAction {
  type: typeof LOGIN;
  data: any;
  onSuccess: (data: any) => void;
  onError: (error: any) => void;
}


// New Redux-based login worker
export function* handleLoginWorker(action: any) {
  try {
    const res: AxiosResponse = yield call(handleLoginApi, { 
      email: action.payload.email, 
      password: action.payload.password 
    });

    if (res?.status === 200 && res.data?.status && res.data?.data?.token) {
      // Fetched before LOGIN_SUCCESS so the post-login redirect already knows
      // which modules this account was granted. A failed read falls back to
      // the role flags (null).
      const user = res.data.data;
      const moduleGrants: string[] | null | undefined = yield call(fetchModuleGrants, user.token, user.user_id);
      yield put(loginSuccess({ ...user, moduleGrants: moduleGrants ?? null }));
      if (action.onSuccess) {
        yield call(action.onSuccess, res.data);
      }
    } else {
      const errorMessage = res.data?.message || 'Login failed';
      yield put(loginFailure(errorMessage));
      if (action.onError) {
        yield call(action.onError, { message: errorMessage });
      }
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Unable to login';
    yield put(loginFailure(errorMessage));
    // Call error callback if provided (for legacy compatibility)
    if (action.onError) {
      yield call(action.onError, error?.response ?? error);
    }
  }
}

// Legacy login worker for backward compatibility
export function* handleLegacyLoginWorker(action: LoginAction) {
  try {
    const res: AxiosResponse = yield call(handleLoginApi, action.data);

    if (res?.status === 200 && res?.data?.status !== false) {
      yield call(action.onSuccess, res.data);
    } else {
      yield call(action.onError, res?.data);
    }
  } catch (error: any) {
    yield call(action.onError, error?.response ?? error);
  }
}

export function* LoginWatcher() {
  yield takeLatest(LOGIN, handleLoginWorker);
}
